import React, { FC } from 'react'

import { LocationDto } from '@apiModels/LocationDto.csharp';

import { useInsuranceLabels } from '../Utils/Context/labelsContext';

import { LocationsCombobox } from './LocationsCombobox';
import { LocationsList } from './LocationsList';
import { KeywordsCombobox } from './KeywordsCombobox';
import { KeywordsList } from './KeywordsList';

interface ChooseSpecialistProps {
  locations: LocationDto[];
}

export const ChooseSpecialist: FC<ChooseSpecialistProps> = (props) => {
  const { locations } = props;

  const {
    headings
  } = useInsuranceLabels();

  return (
    <div className="chooseSpecialist">
      <h1 className="chooseSpecialist__heading">{headings.specialistHeading}</h1>
      <div className="chooseSpecialist__combobox">
        <LocationsCombobox locations={locations} />
      </div>
      {/*Commented per Hakon request*/}
      {/*<div className="chooseSpecialist__keywords">*/}
      {/*  <KeywordsCombobox />*/}
      {/*</div>*/}
      <div className="chooseSpecialist__listLocations">
        <LocationsList />
      </div>
      <div className="chooseSpecialist__listKeywords">
        <KeywordsList />
      </div>
    </div>
  )
};
